import doc                      from '@widesk-core/decorators/doc';
import model                    from '@widesk-core/decorators/model';
import NetworkServiceModel      from '@/models/NetworkServiceModel';

@model.urnResource('owner_user')
@doc.path('/owner_users/{?id}')
export default class OwnerUserModel extends NetworkServiceModel {
	private declare _tsFilters: {
		"id": id;
	};

	private declare _tsSorts: {
		'createdAt': string;
		'id': string;
		'updatedAt': string;
	};
}